var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrainingPilot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  "aria-hidden": "true",
  className: "link-svg",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.503 4.096a1.48 1.48 0 0 0-1.049 0L8.132 6.49l1.442 1.6 5.405-2.046L25.427 10h-8.64a2 2 0 0 0-3.732 1 2 2 0 0 0 3.732 1h8.817l-10.019 3.929-10.53-3.818v.016L3 11l4.566-2.15-1.44-1.6L1.5 9.597C.2 10.089-.304 11.523 1 12l5.055 2.265v10.352l4.072-.563a1 1 0 0 1 .517.08l3.192 1.419a3 3 0 0 0 2.437 0l3.193-1.42a1 1 0 0 1 .517-.08l4.072.564V14.371L28 12.824V18h2v-7a1.48 1.48 0 0 0-.969-1.403zM8.055 22.383v-7.386l6.958 2.913c.34.124.712.12 1.05-.012l.493-.194 5.499-2.524v7.203l-1.851-.317a3 3 0 0 0-1.55.24l-3.193 1.42a1 1 0 0 1-.812 0l-3.193-1.42a3 3 0 0 0-1.55-.24z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.055 19v2h-2v-2z"
})));
export default SvgTrainingPilot;